import { ReactNode } from "react";
import { ArrowRightIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
const BentoGrid = ({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <div className={cn("grid w-full grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto", className)}>
      {children}
    </div>;
};
const BentoCard = ({
  name,
  className,
  background,
  Icon,
  description
}: {
  name: string;
  className: string;
  background: ReactNode;
  Icon: any;
  description: string;
}) => <div key={name} className={cn("col-span-1 flex flex-col overflow-hidden rounded-xl h-auto shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-gray-400 transition-[transform,box-shadow,border-color] duration-400 ease-out", "bg-white border border-gray-300", className)}>

    {/* Content wrapper */}
    <div className="relative z-10 flex flex-col h-full p-6 md:p-8 transition-all duration-300">
      <div className="flex-shrink-0 mb-4">
        <Icon className="h-10 w-10 text-[hsl(var(--color-1))] transition-all duration-300 ease-in-out group-hover/feature:text-[hsl(var(--color-2))]" />
      </div>
      <h3 className="text-card-title mb-3">
        {name}
      </h3>
      <p className="flex-1 font-sans text-base md:text-lg leading-relaxed text-neutral-700 font-light">{description}</p>
    </div>
  </div>;
export { BentoCard, BentoGrid };